"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AnalyticsTracker = /*#__PURE__*/function () {
  function AnalyticsTracker(api) {
    _classCallCheck(this, AnalyticsTracker);

    this.api = api;
  }

  _createClass(AnalyticsTracker, [{
    key: "trackFilter",
    value: function trackFilter(filterKey, value) {
      this.api.trackEvent("".concat(filterKey, "-filter"), {
        value: value
      });
    }
  }, {
    key: "trackSearch",
    value: function trackSearch(query, lat, lng, radius, filters, userIP) {
      this.api.trackEvent('search', {
        query: query,
        lat: lat,
        lng: lng,
        radius: radius,
        filters: filters,
        userIP: userIP
      });
    }
  }, {
    key: "trackLocationClick",
    value: function trackLocationClick(locationId) {
      this.api.trackEvent('location-click', {
        value: locationId
      });
    }
  }, {
    key: "trackMarkerClick",
    value: function trackMarkerClick(locationId) {
      this.api.trackEvent('marker-click', {
        value: locationId
      });
    }
  }, {
    key: "trackMarkerLocationClick",
    value: function trackMarkerLocationClick(locationId) {
      this.api.trackEvent('marker-location-click', {
        value: locationId
      });
    }
  }, {
    key: "trackRickRoll",
    value: function trackRickRoll() {
      this.api.trackEvent('rick-roll', {});
    }
  }]);

  return AnalyticsTracker;
}();

var _default = AnalyticsTracker;
exports.default = _default;